import Reveal from "../components/Reveal";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { trackCta } from "../hooks/useMarketingAnalytics";

export default function ProductTourTeaser() {
  return (
    <section data-testid="product-tour-teaser" className="py-24 lg:py-28 bg-white">
      <div className="max-w-5xl mx-auto px-5 sm:px-8">
        <Reveal>
          <div className="rounded-3xl bg-gradient-to-br from-[#FDE9D8] via-[#FAF7F2] to-[#F0E2D0] border border-[#EDE1D0] p-8 sm:p-12 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
            <div>
              <div className="text-[13px] font-semibold uppercase tracking-[0.14em] text-[#B85C1F] mb-2">
                Product tour
              </div>
              <h2 className="font-display font-extrabold text-[26px] sm:text-[34px] leading-tight tracking-[-0.02em] text-[#1A2A3A]">
                See it in two minutes. No signup required.
              </h2>
            </div>
            <Link
              to="/product-tour"
              onClick={() => trackCta("teaser_tour")}
              className="inline-flex items-center gap-2 px-6 py-3.5 rounded-full bg-[#334E68] hover:bg-[#1B2C3F] text-white text-[15px] font-semibold whitespace-nowrap"
            >
              Take the tour <ArrowRight size={16} />
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
